<template>
  <div class="container">
    <van-button class="button"
                round
                @click="openPopup()"
                type="info"
                size="large">下载IOS客户端</van-button>
    <van-dialog class="dialog"
                v-model="Show"
                title="验证"
                show-cancel-button>
      <div class="container__dialog">
        <span class="container__dialog__text">
          下载之前，需要进行一个资格验证,
          请输入您的上海市律师协会OA系统登录账号和密码
        </span>
        <div class="vip__username">
          <span class="vip__username__span">会员号/律师执业证号</span>
          <input type="text"
                 placeholder="请输入"
                 v-model="Username"
                 class="vip__username__input" />
        </div>
        <div class="vip__username">
          <span class="vip__username__span">密码</span>
          <input type="password"
                 placeholder="请输入"
                 v-model="Password"
                 class="vip__username__input" />
          <a href="http://passport3.lawyers.org.cn/findpwd.jsp"
             class="forget">忘记密码</a>
        </div>
        <div class="container__dialog__button">
          <van-button round
                      type="info"
                      class="container__dialog__button__confirm"
                      @click="Confirm()">确认</van-button>
          <van-button color="#eeeeee"
                      round
                      class="container__dialog__button__signout"
                      @click="SignOut()">退出</van-button>
        </div>
      </div>
    </van-dialog>
  </div>
</template>

<script>
export default {
  name: "Verification",
  props: {},
  data () {
    return {
      Show: false,
      Username: "",
      Password: "",
    };
  },
  methods: {
    openPopup () {
      this.Show = true;
    },
    SignOut () {
      this.Show = false;
    },
    Confirm () { },
  },
};
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
.container {
  text-align: center;
  .dialog {
    // height: 10.5rem;
    width: 70%;
    box-sizing: border-box;
  }
  .container__dialog {
    width: 100%;
    // height: 8.6rem;
    padding: 0.2rem 0;
    .container__dialog__text {
      width: 6rem;
      display: inline-block;
      text-align: left;
      font-family: PingFang SC;
      font-size: 0.28rem;
      color: #007aff;
    }
    .vip__username {
      padding-top: 0.7rem;
      padding-left: 0.5rem;
      text-align: left;
      .vip__username__span {
        display: block;
        margin-bottom: 0.2rem;
        font-size: 0.26rem;
        font-family: PingFang SC;
        font-weight: bold;
      }
      .vip__username__input {
        height: 0.8rem;
        width: 5.7rem;
        padding-left: 0.2rem;
        background: rgba(0, 0, 0, 0.03);
        border: 1px solid rgba(0, 0, 0, 0.2);
        outline: none;
        font-size: 0.2rem;
        opacity: 1;
        border-radius: 8px;
      }
    }
    .container__dialog__button {
      .container__dialog__button__confirm {
        height: 0.8rem;
        width: 3rem;
        display: block;
        margin: 0 auto;
        margin-top: 0.6rem;
        line-height: 0.8rem;
        text-align: center;
        font-size: 0.2rem;
      }
      .container__dialog__button__signout {
        height: 0.8rem;
        width: 3rem;
        display: block;
        margin: 0 auto;
        margin-top: 0.3rem;
        line-height: 0.8rem;
        font-size: 0.2rem;
        text-align: center;
        .van-button__text {
          font-family: PingFang SC;
          color: #000;
        }
      }
    }
  }
  .button {
    width: 4rem;
    height: 0.8rem;
    margin-top: 4rem;
    line-height: 0.8rem;
    font-family: PingFang SC;
    font-size: 0.27rem;
  }
  /deep/ .van-dialog__confirm,
  .van-dialog__confirm:active {
    display: none;
  }
  /deep/ .van-dialog .van-button {
    display: none;
  }
  /deep/ .van-dialog__header {
    padding: 0.25rem;
    padding-left: 0.6rem;
    text-align: left;
    font-size: 0.32rem;
    font-weight: bold;
    border-bottom: 1px solid rgba(0, 0, 0, 0.14901960784313725);
  }
  .forget {
    display: block;
    padding-right: 0.5rem;
    font-size: 0.12rem;
    text-align: right;
  }
}
</style>